import { component } from 'picoapp'
import { zelektor, loopify } from '@/lib/utility-functions.js'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { brandItem: brandItems } = zelektor(node)


    /*******************************************************************************************************************************************/
    /* Init
    /*******************************************************************************************************************************************/
    init()


    /*******************************************************************************************************************************************/
    /* Functions
    /*******************************************************************************************************************************************/
    function init() {
        loopify(brandItems).forEach(item => {
            const { brandLogo } = zelektor(item)
            const { name } = item.dataset

            const matchingBrand = window.theme.brands.find(brand => brand.vendor_name === name)
            if (matchingBrand) insertBrandLogo(brandLogo, matchingBrand)
        })
    }

    function insertBrandLogo(logoEl, brand) {
        logoEl.innerHTML = `<img src="${brand.logo_dark}">`
    }
})